module.exports = __webpack_public_path__ + "static/customize2-ba43859ce657a415e72e75660e8133ad.png";